export default {
  pageView: {
    index: 'pageview.wxservice.fuli_homepage',
    // 福利专区活动卡片曝光
    activityCard: 'pageview.wxshop.dayfuli_position',
    // 日常福利曝光
    daily: 'pageview.wxshop.dayfuli',
    // 周五专区曝光
    friday: 'pageview.wxshop.fridayfuli',
    // 顶部周五专区楼层曝光
    top: 'pageview.wxshop.fridayfuli_top',
    // Activity 页面曝光
    activity: 'pageview.fulizhuanqu.activity',
    edu1: 'pageview.wxservice.fuli_edu1',
    edu2: 'pageview.wxservice.fuli_edu2',
    // 日常福利_顶部banner曝光 banner0/banner1...
    gameBanner: 'pageview.wxshop.dayfuli_banner',
    // 日常福利_新游预约banner曝光 banner0/banner1...
    indexReserverGame: 'pageview.wxshop.dayfuli_gamebanner',
    // 日常福利_专属特价列表曝光
    dayfuliOnsaleList: 'pageview.wxshop.dayfuli_onsaleList',
    // 日常福利_礼包天天领列表曝光
    packageList: 'pageview.wxshop.dayfuli_packageList',
    // 周五专区楼层卡片曝光
    topCardList: 'pageview.wxshop.fridayfuli_top_cardList',
    // 服务订阅底栏曝光
    subscribeFooter: 'pageview.wxshop.dayfuli_subscribe_footer'
  },
  click: {
    // 福利专区活动卡片点击
    userGuide: 'click.wxshop.user_guide',
    activityCard: 'click.wxshop.dayfuli_position',
    indexBanner: 'click.fulizhuanqu.index.banner.ads',
    // 日常福利_新游预约banner点击 banner0/banner1...
    indexReserverGame: 'click.wxshop.dayfuli_gamebanner',
    indexSwiper: 'click.fulizhuanqu.swiper.ads',
    indexFixed: 'click.fulizhuanqu.fixed.ads',
    dayBanner: 'click.wxservice.dayfuli_banner',
    // 日常福利_列表广告位 list0/list1/list2...
    dayList: 'click.wxshop.dayfuli_list',
    more: 'click.wxservice.dayfuli_morefuli',
    // 日常福利_顶部banner点击 banner0/banner1...
    gameBanner: 'click.wxshop.dayfuli_banner',
    dy: 'click.wxservice.fuli_dy',
    // 周五专区_顶部banner banner0
    fridayBanner: 'click.wxshop.fridayfuli_banner',
    // 周五专区_列表广告位 list0/list1/list2...
    fridayList: 'click.wxshop.fridayfuli_list',
    // 日常福利_专属特价列表点击
    dayfuliOnsaleList: 'click.wxshop.dayfuli_onsaleList',
    // 日常福利_专属特价列表展开更多
    dayfuliOnsaleListUnfold: 'click.wxshop.dayfuli_onsaleList_unfold',
    // 日常福利_礼包天天领列表点击 packageList0/packageList1...
    packageList: 'click.wxshop.dayfuli_packageList',
    // 日常福利_礼包天天领列表展开更多
    packageListUnfold: 'click.wxshop.dayfuli_packageList_unfold',
    // 日常福利_跳转新游集合页
    allreservation: 'click.wxshop.dayfuli_allreservation',
    // 周五专区楼层_卡片点击 list0/list1/list2...
    topList: 'click.wxshop.fridayfuli_top_list',
    // 周五专区楼层 卡片隐藏
    topListFold: 'click.wxshop.fridayfuli_top_list_fold',
    // 周五专区楼层 卡片展开
    topListUnfold: 'click.wxshop.fridayfuli_top_list_unfold',
    // 服务订阅底栏点击
    subscribeFooter: 'click.wxshop.dayfuli_subscribe_footer'
  }
}
